import { useEffect, useRef, useState } from 'react'
import WaveSurfer from 'wavesurfer.js'
import { useDispatch, useSelector } from 'react-redux';
import { handleVoiceAudioTime } from 'redux/counterSlice';

interface AudioDataType {
    wavesurferRef2: any
    audioSrc: string,
    isPlaying: boolean,
    setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>
}

const AudioPlayer = ({ wavesurferRef2, audioSrc, isPlaying, setIsPlaying }: AudioDataType) => {
    const dispatch = useDispatch();
    const containerRef: any = useRef()
    // const wavesurferRef2: any = useRef()
    // const waveSurferRef: any = useRef({
    //     isPlaying: () => false,
    // })
    // const wordsWithTime = [
    //     { word: 'Sarah', time: 5 },
    //     { word: 'Mark', time: 15 },
    //     // Add more words and their associated times
    // ];

    const duration: Number = useSelector((state: any) => state.counter.sentance_time);
    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = (seconds % 60).toFixed(6);

        const paddedMinutes = String(minutes).padStart(2, '0');
        const paddedSeconds = remainingSeconds.padStart(9, '0');

        return `${paddedMinutes}:${paddedSeconds}`;
    };

    // const [isPlaying, setIsPlaying] = useState<boolean>(false);
    useEffect(() => {
        if (audioSrc !== "" || audioSrc !== null) {

            // Decode base64 string
            const binaryData = atob(audioSrc);

            // Create Blob
            const arrayBuffer = new ArrayBuffer(binaryData.length);
            const view = new Uint8Array(arrayBuffer);
            for (let i = 0; i < binaryData.length; i++) {
                view[i] = binaryData.charCodeAt(i);
            }
            const blob = new Blob([arrayBuffer], { type: 'audio/mp3' });

            // Create Object URL
            const objectURL = URL.createObjectURL(blob);

            wavesurferRef2.current = WaveSurfer.create({
                container: containerRef.current,
                barGap: 5,
                height: 40,
                progressColor: "#717171", // $primary
                waveColor: "#DEDEDE", // $text_lt_lighter
                normalize: true,
                barWidth: 3,
                barRadius: 3
            })
            wavesurferRef2.current.load(objectURL);

            // Add event listener for onFinish
            wavesurferRef2.current.on('finish', () => {
                setIsPlaying(false); // Set isPlaying to false when the waveform finishes
            });

            // Add event listener for audioprocess
            wavesurferRef2.current.on('audioprocess', () => {
                const currentTime = wavesurferRef2.current.getCurrentTime(); // Get the current time
                dispatch(handleVoiceAudioTime(formatTime(currentTime)));
                // You can use currentTime as needed, for example, to display the current time in your UI
            })

             // Add event listener for the interaction event
             wavesurferRef2.current.on('interaction', () => {
                const currentTime = wavesurferRef2.current.getCurrentTime();
                dispatch(handleVoiceAudioTime(formatTime(currentTime)));
            });

            return () => {
                wavesurferRef2.current.destroy();
                URL.revokeObjectURL(objectURL);
            }
        }
    }, [audioSrc])

    const seekToTime = (timeInSeconds: any) => {
        // Check if wavesurferRef.current is available
        if (wavesurferRef2.current) {
            wavesurferRef2.current.seekTo(timeInSeconds === 0 ? 0 : timeInSeconds / wavesurferRef2.current.getDuration());
        }
    };

    const handleSeekButtonClick = () => {
        // Example: Seek to 30 seconds when the button is clicked
        seekToTime(duration);
    };

    useEffect(() => {
        // if (duration !== 0) {
        handleSeekButtonClick();
        // }
    }, [duration])

    const handlePlayPauseClick = () => {
        if (wavesurferRef2.current) {
            if (isPlaying) {
                wavesurferRef2.current.pause();
            } else {
                wavesurferRef2.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    return (
        <div className="card audio-file-main">
            <div className="card-body">
                <div className='d-flex align-items-center justify-content-between audio-file-btn-wrap'>
                    <span
                        onClick={handlePlayPauseClick} className='c-pointer' >
                        {isPlaying ? <i style={{ fontSize: "xx-large" }} className="fa-solid fa-circle-pause"></i> : <i style={{ fontSize: "xx-large" }} className="fa-solid fa-circle-play"></i>}
                    </span >
                    <div className='audioFile'>
                        <div ref={containerRef} />
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AudioPlayer